import { AxiosResponse } from "axios";
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
  putRequest
} from "services/client/request";
import { AllUsers, AllUsersRequest } from "types/AllUsers";
import { User } from "types/User";
import { NewUser } from "types/Authentication";
import { AxiosGenericResponse } from "types/common";
import { mockUser } from "./mock";
import { Business } from "types/Dashboard";

const apiVersion = "/api/v1";

export const getAllUsersAndDrivers = async (
  request: AllUsersRequest
): Promise<AllUsers> => {
  const allUsers: AllUsers = mockUser.success
    ? (mockUser.data as any)
    : ({} as AllUsers);
  return allUsers;
};

export const getUserById = async (
  accessToken: string,
  userId: number
): Promise<NewUser> => {
  const response: AxiosResponse<AxiosGenericResponse<NewUser>> =
    await getRequest(`${apiVersion}/users/${userId}`, accessToken);

  const allUsers: NewUser = response.data.success
    ? response.data.data
    : ({} as NewUser);
  return allUsers;
};

export const getAllUsersAndDriversWithoutPagination = async (
  role_id: string,
  accessToken: string
): Promise<User[]> => {
  // const response: AxiosResponse = await getRequest(
  //   `${apiVersion}/users?role_id=${role_id}&all=${true}`,
  //   accessToken
  // );

  return mockUser.data.data as any;
};

export const createNewUser = async (
  request: NewUser,
  accessToken: string
): Promise<boolean> => {
  const response: AxiosResponse = await postRequest(
    `${apiVersion}/users`,
    accessToken,
    request
  );
  return response.data.success;
};

export const updateExistingUser = async (
  request: NewUser,
  accessToken: string
): Promise<boolean> => {
  const response: AxiosResponse = await putRequest(
    `${apiVersion}/users/${request.id}`,
    accessToken,
    request
  );
  return response.data.success;
};

export const removeUsers = async (
  request: NewUser,
  accessToken: string
): Promise<boolean> => {
  const response: AxiosResponse = await deleteRequest(
    `${apiVersion}/users`,
    accessToken,
    request
  );
  return response.data.success;
};

export const updateExistingBusinessDetails = async (
  request: Business,
  accessToken: string
): Promise<Business> => {
  const response: AxiosResponse = await patchRequest(
    `${apiVersion}/business/update/${request.id}`,
    accessToken,
    request
  );
  return response.data;
};

export const getCustomers = async (
  accessToken: string,
  businessId: string,
  page: number,
  name?: string
): Promise<AllUsers> => {
  const response: AxiosResponse<AllUsers> = await getRequest(
    `${apiVersion}/business/${businessId}/customers?page=${page}&name=${name}`,
    accessToken
  );

  const allUsers: AllUsers = response.data ? response.data : ({} as AllUsers);
  return allUsers;
};

export const updateProfileAPI = async (
  accessToken: string,
  request: { old_password: string; new_password: string }
): Promise<void> => {
  await postRequest(`${apiVersion}/user/profile/update`, accessToken, request);
};
